module.exports = __webpack_public_path__ + "static/61324315_1286745254823877_7384449980544581632_o_optimized-a1f8f9e1b8c24dea0d97ff17785d8280.jpg";